import { Component, AfterContentInit, ElementRef, OnInit, OnDestroy, Optional } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { AwardDTO, ProcurementProjectDTO, ProjectEntityDTO, ProjectRelationDTO, ResultTypeDTO } from '../../api/plyca-dtos-v2';
import { BaseFormComponent, BaseFormHeaderInfo } from '../../tasks/baseFormComponent/baseForm.component';
import { AppConfiguration } from '../../conf/app.configuration';
import { Configuration } from '../../conf/app.constants';

import { HelpService } from '../../components/common/help/help.service';
import { of, Observable, forkJoin, EMPTY } from 'rxjs';
import { FormConfig } from '../../components/forms/form.objects';
import { tap, finalize, catchError } from 'rxjs/operators';
import { PlycaErrorHandler } from '../../../http/PlycaErrorHandler';
import { CertificationPaymentDTO, ParticipantPaymentDTO, SpendingProjectDTO } from '../../api/dipbad-dtos';
import { ProfileService } from '../../../services/profile.services';
import * as lodash from 'lodash';
import { UserService } from '../../user.service';
import { SelectItem } from 'primeng-lts/api';
import { getSimpleIdentifierFromString } from '../../api/plyca-dtos';

export class CertificationPaymentModel {

  dto: CertificationPaymentDTO;
  ui: {
    project: ProcurementProjectDTO;
    listSpendingprojects: SpendingProjectDTO[];
    spendingproject: SpendingProjectDTO;
    award: AwardDTO;
    projectEntity: ProjectEntityDTO;
    listMonth: any;
    awardBudget: number;
    contractnumber: string;
    contractType: string;
  }
}

@Component({
  selector: 'certificationpayment-form',
  templateUrl: '../../tasks/baseFormComponent/baseForm.template.html'
})
export class CertificationPaymentComponent
  extends BaseFormComponent<CertificationPaymentDTO, CertificationPaymentModel>
  implements OnInit, OnDestroy, AfterContentInit {
  headerService: any;
  private identifier: string;
  public readonly = false;
  private dossierId: string;


  constructor(
    elem: ElementRef,
    @Optional() protected activatedRoute: ActivatedRoute,
    private router: Router,
    protected appConfig: AppConfiguration,
    public configuration: Configuration,
    private plycaErrorHandler: PlycaErrorHandler,
    public helpService: HelpService,
    public profileService: ProfileService,
    public userService: UserService
  ) {
    super(elem);

  }



  ngAfterContentInit(): void {
    this.loadData();



    this.waitService.cancelWaiting();
  }

  /*protected postLoadForm(): Observable<any> {
    if (this.model.ui.projectEntity && this.model.ui.projectEntity.identifier) {
      return forkJoin([
        this.plycaService.get<SpendingProjectDTO>(this.configuration.UserApiUrl + this.configuration.ApiVersion + 'spendingProjects/', this.model.ui.projectEntity.identifier).pipe(
          catchError((error: any) => {
            console.error(error);
            return EMPTY
          })
        ),

        //this.plycaService.getProcurementProjectWithLot(this.dossierId),
        //this.plycaService.getDossierAwards(this.dossierId),

      ]).pipe(
        tap(result => {
          // 1. recuperar información del expediente
          this.model.ui.listSpendingprojects = result[0];
          if (this.model.ui.listSpendingprojects !== undefined && this.model.ui.listSpendingprojects.length > 0) {
            if (this.model.ui.listSpendingprojects.length === 1) {
              this.model.ui.spendingproject = this.model.ui.listSpendingprojects[0];
            }
          }
          //this.model.ui.award = result[1].content[0];
        })
      );

      this.updatePaymentAmount(this.model);
    } else {
      return EMPTY;
    }



  }*/

  loadData(): void {
    //this.model.ui.project = this.task.division.project;
    this.dossierId = this.task.division.project.identifier;
  }

  getFormSettingURL(): string {
    return 'certificationPayment/certificationPaymentInterfaceSettings.json';
  }

  close() { }

  dtoToModel(dto: CertificationPaymentDTO): Observable<CertificationPaymentModel> {
    let model = new CertificationPaymentModel();
    model.dto = dto;
    model.ui = {
      project: new ProcurementProjectDTO,
      spendingproject: new SpendingProjectDTO,
      listSpendingprojects: [],
      award: new AwardDTO,
      projectEntity: undefined,
      listMonth: [],
      awardBudget: 0.0,
      contractnumber: "",
      contractType: ""
    }

    if (this.task !== undefined) {
      if (this.task.work) {
        if (this.task.work.certificationPayment === undefined) {
          this.uiService.showMessage(
            'Se ha producido un error en la carga de datos de la certificación. ' +
            'Consulte con el administrador. ',
            'Aviso',
            'errorStyle'
          );
        }
        model.dto = this.task.work.certificationPayment;
        model.ui.project = this.task.division.project;
        if (model.dto.division !== undefined &&
          model.dto.division.project !== undefined &&
          model.dto.division.project.projectRelations !== undefined) {
          let relationProject = new ProjectRelationDTO();
          relationProject = model.dto.division.project.projectRelations[4];
          if (relationProject) {
            if (relationProject.relationsAsSecundary !== undefined
              && relationProject.relationsAsSecundary.length > 1) {
              //lista de proyectos para cargar en el buscador
            } else if (relationProject.relationsAsSecundary !== undefined
              && relationProject.relationsAsSecundary.length === 1) {
              model.ui.projectEntity = relationProject.relationsAsSecundary[0]
            }

          }

        }


      }

    }

    if (model.dto.listMonth) {
      model.ui.listMonth = model.dto.listMonth
        .map((month: string) => {
          return {
            label: month,
            value: month
          } as SelectItem;
        });
    } else {
      model.ui.listMonth = {};
    }

    if (model.ui.project.classification.typeCode.identifier === '01<>TIPOEXPTE') {
      model.ui.contractType = "Obras";
    } else if (model.ui.project.customFields.SUBTIPO_EXPTE) {
      switch (model.ui.project.customFields.SUBTIPO_EXPTE) {
        case "0": {
          model.ui.contractType = "Dirección";
          break;
        }
        case "1": {
          model.ui.contractType = "Redacción";
          break;
        }
        case "2": {
          model.ui.contractType = "Coordinación";
          break;
        }
        case "3": {
          model.ui.contractType = "Redacción y Dirección";
          break;
        }
        case "4": {
          model.ui.contractType = "Redacción - Dirección - Coordinación";
          break;
        }
        case "5": {
          model.ui.contractType = "Control de Calidad";
          break;
        }
        case "6": {
          model.ui.contractType = "Estudio Geotecnico";
          break;
        }
        case "7": {
          model.ui.contractType = "Auditoria";
          break;
        }
        case "8": {
          model.ui.contractType = "Otros";
          break;
        }
      }

    }



    if (model.dto.award && model.dto.award.awardsLots) {
      model.dto.award.awardsLots.forEach(awardLot => {
        model.ui.awardBudget = model.ui.awardBudget + awardLot.amount;
      })
    }
    if (model.dto.division && model.dto.division.parent && model.dto.division.parent.identifier) {
      model.ui.contractnumber = getSimpleIdentifierFromString(model.dto.division.parent.identifier);
    }

    this.updatePaymentAmount(model);


    // TODO faltaría el de la descripción. E igual también el de las anualidades.

    let modelObs: Observable<CertificationPaymentModel>;
    modelObs = of(model);
    return modelObs;
  }

  modelToDTO(model: CertificationPaymentModel): CertificationPaymentDTO {

    return model.dto;
  }

  getHeaderInfo(): BaseFormHeaderInfo {
    let headerInfo = new BaseFormHeaderInfo();
    headerInfo.titleKey = 'Conformidad de gasto';
    headerInfo.titleIcon = 'fas fa-envelope-open-text';

    return headerInfo;
  }

  getObjectIdentifier(): string {
    let identifier: string;
    if (this.task && this.task.work) {
      identifier = this.task.work.certificationPayment.identifier;
    } else if (this.identifier) {
      identifier = this.identifier;
    } else {
      // nueva certificación
      //identifier = 'new';
    }
    return identifier;
  }


  getServiceURL(): string {
    return this.configuration.UserApiUrl + this.configuration.ApiVersion + 'certificationPayments/';
  }

  initHeaderActions() {
    if (!this.readonly) {
      this.subscribe(this.headerActionsService
        .addAction('Verificar', 'fas fa-check', 'btn-primary', true)
        , (() => {
          this.validateCertification();
        }));
      this.subscribe(this.headerActionsService
        .addAction('Guardar', 'fas fa-save', 'btn-primary', true)
        , (
          () => {

            this.subscribe(this.saveIfValid(),
              _model => {
                if (_model.work && _model.work.certificationPayment && _model.work.certificationPayment.identifier) {
                  this.model.dto.identifier = _model.work.contract.identifier;

                }
              }
            );

          }
        )
      );
    }

    this.headerActionsService.addDivider();
    this.addBack();
  }


  protected addBack() {
    this.subscribe(
      this.headerActionsService
        .addAction(
          'General.back',
          'fas fa-chevron-left',
          'btn-outline-secondary',
          true
        )
      , (success => {
        if (this.task !== undefined) {

        }
        this.salir();
      }));
  }

  configureFormConfig(formConfig: FormConfig): Observable<FormConfig> {
    formConfig.readonly = this.readonly;
    formConfig.functions.push({
      identifier: 'updatePaymentAmount',
      fn: this.updatePaymentAmount
    });
    /*formConfig.functions.push({
      identifier: 'recalParticipants',
      fn: this.recalParticipants
    });*/



    return super.configureFormConfig(formConfig);
  }

  showConfirmMessage(_certificationPayment: CertificationPaymentDTO) {
    this.uiService.showConfirmMessage({
      // ¿Desea iniciar la tramitación de la incidencia?
      message: this.translateService.instant('ContractModification.message_start_processing'),
      header: 'Confirmation',
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.waitService.startWaiting();
        this.subscribe(this.plycaService.insert(this.getServiceURL(), _certificationPayment)
          .pipe(
            finalize(() => {
              this.waitService.cancelWaiting();
            })
          ),
          () => {
            console.log('Error');
          }
        );
      },
      reject: () => {
        console.log('Saliendo...');
      }
    });
  }

  validateCertification() {

    this.subscribe(this.validate(), (result => {
      if (result.result === ResultTypeDTO.OK) {
        this.uiService.showMessage(
          'Se ha validado correctamente.',
          'Aviso',
          'errorStyle'
        );
      }
    }))
  }

  public updatePaymentAmount(model: any) {
    let dto: CertificationPaymentDTO;
    dto = model.dto;

    let importe = 0.0;
    if (dto.initialContractAmount !== undefined && dto.initialContractAmount !== 0.0) {
      importe = importe + dto.initialContractAmount;
    }
    if (dto.modificationAmount !== undefined && dto.modificationAmount !== 0.0) {
      importe = importe + dto.modificationAmount;
    }
    if (dto.revisionAmount !== undefined && dto.revisionAmount !== 0.0) {
      importe = importe + dto.revisionAmount;
    }
    if (dto.settlementAmount !== undefined && dto.settlementAmount !== 0.0) {
      importe = importe + dto.settlementAmount;
    }
    dto.amount = importe

    //Calculo del presupuesto total vigente
    //Prespuesto de adjudicación + Presup Modificación + PresupRevision + PresupLiqu
    let totalAmount = 0.0;
    if (model.ui.awardBudget) {
      totalAmount = totalAmount + model.ui.awardBudget;
    }
    if (dto.modificationBudget) {
      totalAmount = totalAmount + dto.modificationBudget;
    }
    if (dto.budgetReview) {
      totalAmount = totalAmount + dto.budgetReview;
    }
    if (model.ui.presupLiq) {
      totalAmount = totalAmount + model.ui.presupLiq;
    }

    model.ui.presupTotalVigente = totalAmount;

    dto.pendingPayment = model.ui.presupTotalVigente - (dto.amountPrev + (dto.initialContractAmount ? dto.initialContractAmount : 0.0))

    let totalAmountCal = dto.amount;
    let participantsAux = new Array<ParticipantPaymentDTO>();
    let loquequedadelpago = totalAmountCal;
    dto.annuity = '';
    try {
      if (dto.budgetAccountLinesContract && dto.budgetAccountLinesContract.length > 0) {
        const map = new Map();
        dto.budgetAccountLinesContract.forEach(budgetAccountLinesContract => {
          let año = budgetAccountLinesContract.year; // Convertir año a entero
          let importeAnualidad = budgetAccountLinesContract.amount; // Convertir importe a float



          if (dto.alreadySpentAnnuities && dto.alreadySpentAnnuities.length > 0) {
            let importeSpentYear: number;
            dto.alreadySpentAnnuities.forEach(spentAnnuity => {
              if (spentAnnuity.year === año) {
                importeSpentYear = spentAnnuity.amount;
              }

            });
            importeAnualidad = importeAnualidad - importeSpentYear;
          }
          if (importeAnualidad > 0 && loquequedadelpago > 0) {
            if (!dto.annuity) {
              dto.annuity = '' + año;
            } else if (dto.annuity.indexOf('' + año) < 0) {
              dto.annuity = dto.annuity + ' ' + año
            }
            //dto.annuity = dto.annuity === undefined ? año : (dto.annuity.indexOf(año) < 0 ? dto.annuity : dto.annuity + ' ' + año);
            if (dto.participantsContract && dto.participantsContract.length > 0) {
              for (let partSeleccionado of dto.participantsContract) {
                if (partSeleccionado.year === año) {
                  let importe = 0.0;

                  if (partSeleccionado.percentagePart != null) {
                    let porcentajePart = partSeleccionado.percentagePart;

                    if (loquequedadelpago <= importeAnualidad) {
                      importe = loquequedadelpago * (porcentajePart / 100);
                    } else {
                      importe = importeAnualidad * (porcentajePart / 100);
                    }

                    partSeleccionado.amount = importe;
                  }

                  participantsAux.push(partSeleccionado);
                }
              }
            }
          }


          //if (loquequedadelpago <= importeAnualidad) {
          loquequedadelpago = loquequedadelpago - importeAnualidad;
          //}

        })
      }
      dto.participants = participantsAux;
    } catch (e) {
    }
  }

  public recalParticipants(model: any) {



  }




}
